export enum WaterHeatExchangerTemperatureCalculationMode {
  OUTLET_TEMPERATURE_TUBE = 'Outlet Temperature - Tube',
  OUTLET_TEMPERATURE_SHELL = 'Outlet Temperature - Shell',
  UA = 'UA',
}
